import { render, staticRenderFns } from "./TwoFactorPrompt.vue?vue&type=template&id=67c72a6b"
import script from "./TwoFactorPrompt.vue?vue&type=script&lang=js"
export * from "./TwoFactorPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports